import { IonContent, IonPage, useIonRouter } from "@ionic/react";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { HeaderComponent } from "../../components";
import "./onBoarding.css";
import { isAndroid, isIos } from "../../services/platformDetection";
import { RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "../../route/constants";
import { OnBoardingWatchRender } from "./onBoardingWatchRender";
import { IQDevice } from "capacitor-garmin-sdk";
import {
    isGarminUnsupportedDevice,
    updateGarminKnownDevices,
    updateSelectedDevice,
} from "../../services/watch/GarminWatchHelper";
import { WatchBluetoothStatus } from "refsix-js-models";

export const getNextPageURL = (
    watchStatus?: WatchBluetoothStatus,
    garminKnownDevices?: IQDevice[]
) => {
    let redirectRoute = routes.onboardingNoWatchFound;
    if (watchStatus?.isPaired) {
        const platform = isIos() ? "apple" : "wearos";
        redirectRoute = `${routes.onboardingFoundWatch}/${platform}`;
    } else if (garminKnownDevices && garminKnownDevices.length) {
        // devices are filtered before they reach redux; unsupported watches
        // go via the select screen where they are shown as not supported
        if (
            garminKnownDevices.length === 1 &&
            !isGarminUnsupportedDevice(garminKnownDevices[0].friendlyName)
        ) {
            updateSelectedDevice(garminKnownDevices[0]).catch((e) => {
                console.error("Could not update selected device", e);
            });
            redirectRoute = routes.onboardingFoundWatch + "/garmin";
        } else {
            redirectRoute = routes.onboardingSelectGarmin;
        }
    }

    return redirectRoute;
};

export const OnboardingFindingYourWatch: FC = () => {
    const { t } = useTranslation();
    const watchStatus = useSelector((state: RootState) => state.watchStatus);
    const route = useIonRouter();
    const garminWatches = useSelector(
        (state: RootState) => state.garminWatches
    );
    const garminKnownDevices = useSelector(
        (state: RootState) => state.garminWatches?.knownDevices
    );
    const [timeoutHandle, setTimeoutHandle] = useState<any>(null);
    const dispatch = useDispatch();

    const cancelTimeout = () => {
        if (timeoutHandle) {
            clearTimeout(timeoutHandle);
            setTimeoutHandle(undefined);
        }
    };

    const startTimeout = (duration: number) => {
        return setTimeout(() => {
            route.push(
                getNextPageURL(watchStatus, garminKnownDevices),
                "forward",
                "replace"
            );
        }, duration);
    };

    useEffect(() => {
        if (
            (isIos() || isAndroid()) &&
            !watchStatus.isPaired &&
            garminWatches?.isConnectInstalled
        ) {
            updateGarminKnownDevices().catch((e) => {
                console.error("Error getting known devices", e);
            });
        }

        // Give iOS longer as we have to jump out to the Garmin Connect App
        const timeoutDuration =
            isIos() &&
            !watchStatus.isPaired &&
            garminWatches?.isConnectInstalled
                ? 10000
                : 3000;
        const t = startTimeout(timeoutDuration);
        setTimeoutHandle(t);
        return () => cancelTimeout();
    }, []);

    useEffect(() => {
        if (garminKnownDevices && garminKnownDevices.length > 0) {
            cancelTimeout();
            // reduce down the timeout for the next page
            const t = startTimeout(1000);
            setTimeoutHandle(t);
        }
    }, [garminKnownDevices]);

    return (
        <IonPage>
            <HeaderComponent
                titleTestId="onboarding-finding-watch"
                title={t("help.onBoarding.step0a")}
                showProgressBar={true}
                progressValue={0.7}
            />
            <IonContent>
                <div style={{ marginTop: 150 }}>
                    <OnBoardingWatchRender
                        text={t("help.onBoarding.findingWatch")}
                        showProgressBar={true}
                    />
                </div>

                {/*<pre>{JSON.stringify(garminWatches, null, 2)}</pre>*/}
            </IonContent>
        </IonPage>
    );
};
